import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { AuthService } from './auth.service';

/** Formats a date with the organization's Date Format setting (Essential Settings → Date Format). */
@Pipe({ name: 'appDate', pure: false })
export class AppDatePipe implements PipeTransform {
  constructor(private auth: AuthService) {}
  transform(value: any, withTime = false): string {
    if (!value) { return ''; }
    const fmt = this.auth.dateFormat + (withTime ? ' HH:mm' : '');
    try {
      // API sends UTC; let the browser show local time
      const d = typeof value === 'string' && !/Z$|[+-]\d\d:\d\d$/.test(value) ? value + 'Z' : value;
      return formatDate(d, fmt, 'en-US');
    } catch (e) { return String(value); }
  }
}

/** Password strength — same rule as the API (Poor / Good / Excellent). */
export function passwordStrength(p: string): 'Poor' | 'Good' | 'Excellent' {
  if (!p) { return 'Poor'; }
  let s = 0;
  if (p.length >= 8) { s++; }
  if (p.length >= 12) { s++; }
  if (/[A-Z]/.test(p) && /[a-z]/.test(p)) { s++; }
  if (/\d/.test(p)) { s++; }
  if (/[^A-Za-z0-9]/.test(p)) { s++; }
  return s >= 4 ? 'Excellent' : s >= 3 ? 'Good' : 'Poor';
}

export const TITLES = ['Mr.', 'Mrs.', 'Ms.', 'Miss', 'Dr.', 'Prof.', 'Rev.', 'Hon.'];

export function graduationYears(): string[] {
  const y = new Date().getFullYear();
  const list: string[] = [];
  for (let i = y - 8; i <= y + 8; i++) { list.push(String(i)); }
  return list;
}
